/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-05.
 * Exporting all reducers inside the containers.
 * This are used to create the store.
 */
import { combineReducers } from 'redux';
import playgroundReducer from './containers/playground/reducer';
import despachosReducer from './containers/despachos/reducer';
import aduanasReducer from './containers/aduanas/reducer';
import userReducer from './containers/users/reducer';
import clientesReducer from './containers/clientes/reducer';
import conceptosReducer from './containers/conceptos/reducer';
import statusesReducer from './containers/status/reducer';
import proveedoresReducer from './containers/proveedores/reducer';
import globalReducer from './global.reducer';

const userDataReducer = (state = {}, { type }) => {
    switch (type) {
        default:
            return state;
    }
};

//TODO renombrar todas las popiedades para que tengan el sufijo State
export default combineReducers({
    playground: playgroundReducer,
    customesClearenceState: despachosReducer,
    aduanas: aduanasReducer,
    users: userReducer,
    customersState: clientesReducer,
    conceptos: conceptosReducer,
    statuses: statusesReducer,
    suppliersState: proveedoresReducer,
    globalData: globalReducer,
    userData: userDataReducer
});



// WEBPACK FOOTER //
// ./reducers.js